import { Navigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useAuthStore } from 'app/stores/StoreContext'
import { useAvailabilityLocation } from 'app/components/availability-location/useAvailabilityLocation'
import { AvailabilityLocationShadcnComponent } from 'app/components/availability-location/AvailabilityLocationShadcnComponent'

const REQUIRED_PRODUCTS = [`Scheduler`, `AI Agent`, `SMS Agent`]

// observer: reads authStore.products in render. products is reassigned in place on a
// workspace switch, so without observer the product gate would not react (TRK-6020).
const LocationView = observer(function LocationView() {
  const { products } = useAuthStore()
  const hasRequiredProduct = products?.some((p) => REQUIRED_PRODUCTS.includes(p)) ?? false

  if (products && !hasRequiredProduct) {
    return <Navigate to="/settings" replace />
  }

  const { title, tabs, onCopyPreview, onCopyLink } = useAvailabilityLocation()
  return (
    <AvailabilityLocationShadcnComponent
      title={title}
      tabs={tabs}
      onCopyPreview={onCopyPreview}
      onCopyLink={onCopyLink}
    />
  )
})

export default LocationView
